import React from 'react'

import type { IconProps } from '../iconProps'
import { s } from './icon.style'

export const DoneAllIcon = React.forwardRef<SVGSVGElement, IconProps>(
  ({ size = 16, name = 'icon', color, style, ...props }: IconProps, ref) => {
    return (
      <svg
        viewBox="0 0 24 24"
        css={s}
        style={{ width: size, color, ...style }}
        data-svg-name={name}
        {...props}
        ref={ref}
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M17.9999 6.99997L16.5899 5.58997L10.2499 11.93L11.6599 13.34L17.9999 6.99997ZM22.2399 5.58997L11.6599 16.17L7.47991 12L6.06991 13.41L11.6599 19L23.6599 6.99997L22.2399 5.58997ZM0.409912 13.41L5.99991 19L7.40991 17.59L1.82991 12L0.409912 13.41Z"
          fill="black"
          fill-opacity="0.87"
        />
      </svg>
    )
  },
)
